import { getVendorStrategies } from "./vendorStrategy";
import { BRANDS } from "./vendorStrategy/constants";
import { type Brand, type VendorStrategies } from "./vendorStrategy/types";

const getVendorLabel = (): Brand => {
  const vendorLabel = window.VENDOR_LABEL;
  if (vendorLabel && BRANDS.includes(vendorLabel)) {
    return vendorLabel as Brand;
  }
  return "mm";
};

const vendorConfigHolder: { config?: ReturnType<VendorStrategies>[Brand] } = {};

export const getVendorConfig = () => {
  if (!vendorConfigHolder.config) {
    vendorConfigHolder.config = getVendorStrategies()[getVendorLabel()];
  }
  return vendorConfigHolder.config;
};
